<template>
  <v-dialog v-model="showBranchSelection" max-width="400px">
    <v-card>
      <v-card-title>
        <span>Select Branch</span>
        <v-spacer></v-spacer>
        <v-btn small icon @click="showBranchSelection = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="profileDetail">
        <v-select
          :items="branchWithAccess"
          label="Select Branch"
          item-text="name"
          hide-details="auto"
          dense
          background-color="background_color"
          item-value="id"
          return-object
          outlined
          :menu-props="{ offsetY: true }"
          v-model="selected"
        ></v-select>
      </v-card-text>
      <v-card-actions class="flex justify-end">
        <v-btn color="primary" depressed @click="changeBranch">Change</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { bus } from "@/main";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      branchWithAccess: [],
      profileDetail: null,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getBranchList();
        this.getSelectedBranch();
      }
    },
  },
  computed: {
    showBranchSelection: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getSelectedBranch() {
      let interval = setInterval(() => {
        let obj = this.$helper.getUserDetailsLocalStorage();
        if (obj) {
          clearInterval(interval);
          this.profileDetail = { ...obj };
          this.selected = this.profileDetail.preferred_branch.id;
        }
      }, 100);
      setTimeout(() => {
        clearInterval(interval);
      }, 2000);
    },
    changeBranch() {
      bus.$emit("showLoader", true);
      let payload = {
        branch:
          typeof this.selected == typeof {} ? this.selected.id : this.selected,
      };
      this.$api.profile
        .updateUserPrefferedBranch(payload)
        .then((res) => {
          this.profileDetail = { ...res.data };
          this.$permissions.setPermissions(res.data)
          bus.$emit("showLoader", false);

          window.location.reload();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getBranchList() {
      this.branchWithAccess = [];
      this.$api.branch
        .getBranchSelectList({ limit: "all" })
        .then((res) => {
          this.branchWithAccess = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
